
export const NEW_FILTER_CALENDARIO = 'NEW_FILTER_CALENDARIO'
export const NEW_FILTER_CALENDARIO_PENDING = 'NEW_FILTER_CALENDARIO_PENDING'
export const NEW_FILTER_CALENDARIO_SUCCESS = 'NEW_FILTER_CALENDARIO_SUCCESS'
export const NEW_FILTER_CALENDARIO_FAILURE = 'NEW_FILTER_CALENDARIO_FAILURE'